// Module
var code = `<div class="colorpicker">
    <button data-bind="click: show,
                       class: selectedColor() || 'color-none',
                       css: {'not-allowed': !editable},
                       attr: {
                           title: translated('Select color'),
                           'aria-label': translated('Select color'),
                       }"></button>
    <fieldset class="colorpicker-pane" data-bind="visible: visible">
        <div class="colorpicker-grid">
            <!-- ko foreach: availableColors -->
            <label data-bind="class: \$data.value,
                              css: {'selected-color': \$data.value == \$parent.selectedColor()},
                              attr: {title: translated('Select Color')+ ' ' + \$data.label}">
                <!-- ko text: \$data.label --><!-- /ko -->
                <input type="radio" data-bind="attr: {
                                      name: \$parent.fieldName,
                                      value: \$data.value,
                                  },
                                  checked: \$parent.selectedColor">

            </label>
            <!-- /ko -->
            <!-- ko if: showNoColorOption -->
            <label class="color-none" data-bind="css: {'selected-color': selectedColor() == ''},
                              attr: {title: translated('No color assigned')}">
                <!-- ko text: translated('No color') --><!-- /ko -->
                <input type="radio" value="" data-bind="attr: {
                                      name: fieldName,
                                  },
                                  checked: selectedColor">

            </label>
            <!-- /ko -->
        </div>
    </fieldset>
</div>
`;
// Exports
export default code;